import { render } from "./TotalSales.vue?vue&type=template&id=3711252c&scoped=true"
import script from "./TotalSales.vue?vue&type=script&lang=js"
export * from "./TotalSales.vue?vue&type=script&lang=js"

import "./TotalSales.vue?vue&type=style&index=0&id=3711252c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3711252c"]])

export default __exports__